import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { AuthGuard, I18nModule, UrlModule } from '@spartacus/core';
import { CmsPageGuard, IconModule, MediaModule } from '@spartacus/storefront';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { KbCustomerIdDropdownModule } from '../kb-myAccount/kb-MyOwnPartNumbers/customer-id-drop-down/customer-id-drop-down.module';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { KbMyAccountLeftSideNavModule } from '../kb-myAccount/my-account-left-sidenav/my-account-left-sidenav.module';
import { MyQuotesDetailsComponent } from './my-quotes-details/my-quotes-details.component';
import { MyQuotesListComponent } from './my-quotes-list/my-quotes-list.component';
import { SecureGuard } from 'src/app/services/Guards/secure.service';
import { KbPaginationModule } from '../kb-pagination/kb-pagination/kb-pagination.module';
@NgModule({
  declarations: [ MyQuotesListComponent, MyQuotesDetailsComponent],
  imports: [
    CommonModule,
    RouterModule,
    UrlModule,
    IconModule,
    I18nModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MediaModule,
    KbCustomerIdDropdownModule,
    KbMyAccountLeftSideNavModule,
    ReactiveFormsModule,
    BsDatepickerModule,
    KbPaginationModule,
    RouterModule.forChild([

      {
        path: 'my-quotes/:quoteId',
        data: { pageLabel: '/my-quotes' },
        component: MyQuotesDetailsComponent,
        canActivate: [CmsPageGuard, SecureGuard, AuthGuard],
      },
    ])
  ],
})
export class KbMyQuotesModule {}
